export const ID = 'fefab30d-92d1-4d4d-89fb-3c2c7864fd1d';

export const NAME = 'Facility Image: Slideshow';
